var _rect, _path, _path2, _g, _g2, _g3, _rect2, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerificationplaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 900,
    viewBox: "0 0 1200 900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustrative placeholder: vehicle safety") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 900,
    fill: "#edf4fa"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 555h1200v345H0z",
    fill: "#dce9e5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 700h1200v200H0z",
    fill: "#c3d1de"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(110 370) scale(1.22)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#123047",
    strokeWidth: 5,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 580,
    height: 245,
    rx: 32,
    fill: "#f5b938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 80h535M22 165h535",
    stroke: "#b47818"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 25,
    width: 98,
    height: 90,
    rx: 8,
    fill: "#a6d6e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 25,
    width: 98,
    height: 90,
    rx: 8,
    fill: "#a6d6e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 25,
    width: 98,
    height: 90,
    rx: 8,
    fill: "#a6d6e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 25,
    width: 78,
    height: 184,
    rx: 8,
    fill: "#bfdfeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 25,
    width: 88,
    height: 90,
    rx: 8,
    fill: "#a6d6e5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 239,
    r: 40,
    fill: "#123047"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 239,
    r: 18,
    fill: "#cbd5e1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 239,
    r: 40,
    fill: "#123047"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 239,
    r: 18,
    fill: "#cbd5e1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535,
    y: 144,
    width: 24,
    height: 18,
    rx: 5,
    fill: "#fff4cc"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(935 505) scale(1.25)",
    stroke: "#123047",
    strokeWidth: 4,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cy: -100,
    r: 28,
    fill: "#e6bc91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30-121q30-30 60 0",
    fill: "#123047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39-60q39-20 78 0l12 99h-102z",
    fill: "#278166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23 42v77m46-77v77m-62-162-23 68m101-68 23 68",
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#123047",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 240,
    width: 190,
    height: 225,
    rx: 18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m795 325 20 20 39-43m-59 85 20 20 39-43",
    stroke: "#278166",
    strokeWidth: 9,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875 327h40m-40 60h40",
    stroke: "#bdcddd"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 35,
    width: 280,
    height: 42,
    rx: 10,
    fill: "#fff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 63,
    fill: "#64748b",
    fontFamily: "Arial,sans-serif",
    fontSize: 20
  }, "ILLUSTRATIVE PLACEHOLDER")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationplaceholder);
export default __webpack_public_path__ + "static/media/verification.placeholder.6fb9c144ebbaf8122feb6025b276c85f.svg";
export { ForwardRef as ReactComponent };